<template>
  <div class="interactives-input">
    <component :is="inputData.type"
      :inputData="inputData"/>
  </div>
</template>

<script>
import TextInput from './components/TextInput'
import TextareaInput from './components/TextareaInput'
import Dropdown from './components/Dropdown'
import CheckInput from './components/CheckInput'
import RadioInput from './components/RadioInput'
import ListBuilder from './components/ListBuilder'

export default {
  name: 'interactives-input',
  props: ['inputData'],
  components: {
    'text-input': TextInput,
    'textarea-input': TextareaInput,
    'dropdown': Dropdown,
    'check-input': CheckInput,
    'radio-input': RadioInput,
    'list-builder': ListBuilder
  }
}
</script>

<style>
.interactives-input {
  /* styles go here */
}
</style>



// WEBPACK FOOTER //
// ../interactives-input/src/App.vue